<div>
    <div class="page-title">
        <h1>Shipment #{{id}}
            <button class="btn btn-primary" routerLink="/main/shipments">Back</button>
        </h1>
    </div>
    <div class="page-body">
            <div class="row justify-content-center mt-3">
                <div class="col-md-2 text-center" *ngIf="pdfSrc">
                    <div class="card">
                        <a [href]="pdfSrc" target="_blank"><i class="icon-eye icon-btn"></i></a>
                        <label class="mt-3">View </label>
                    </div>
                </div>
                <div class="col-md-2 text-center" *ngIf="pdfSrc">
                    <div class="card">
                        <a (click)="print()"><i class="icon-printer icon-btn"></i></a>
                        <label class="mt-3">Print </label>
                        <div class="mt-3" *ngIf="printDetails">
                            <div>
                                <span>Job ID </span><br><label>{{printDetails?.jobId}}</label>
                            </div>
                            <div>
                                <span>Transaction ID </span><br><label>{{printDetails?.originalTransactionId}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-md-6 text-center" *ngIf="pdfSrc">
                    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"></pdf-viewer>
                </div> -->

                <div class="col-md-6 text-center" *ngIf="!pdfSrc">
                    <h4 class="text-center">No Label Found</h4>
                </div>
            </div>
    </div>
</div>